import {TOperatingSystem} from '@/typings/typings'

export function makeUrl(storeAppId: string, os: TOperatingSystem) {
    if (os === 'android') {
        return process.env.VUE_APP_GOOGLE_PLAY_URL_TEMPLATE.replace('@', storeAppId)
    }

    return process.env.VUE_APP_APP_STORE_URL_TEMPLATE.replace('@', storeAppId)
}